import React from "react";
import styled from "styled-components";
import { FontWeight, Spacing, content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import { tr } from "@radarly/i18n";

export interface IProps {
  page: { from: number; to: number };
  locale: Locale;
  totalItems: number;
  showPagination: boolean;
  isDetailView: boolean;
  isFullscreen: boolean;
  onPageUp: () => void;
  onPageDown: () => void;
  onClick?: () => void;
}

const Footer = styled.footer<{ isStretched: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isStretched }) =>
    isStretched ? "space-between" : "center"};
  margin-top: ${Spacing.Large};
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => content(props, "secondary")};
  font-weight: ${FontWeight.Normal};
`;

const Counter = styled.div<{ isDetailView?: boolean }>`
  margin: ${({ isDetailView }) =>
    isDetailView ? `${Spacing.Medium} 0 0 0` : `0 ${Spacing.Medium}`};
`;

const RadarlyWidgetImageClusteringFooter = ({
  page,
  onPageUp,
  onPageDown,
  locale,
  totalItems,
  showPagination,
  isDetailView,
  isFullscreen,
  onClick,
}: IProps) => {
  return (
    <Footer isStretched={isDetailView || isFullscreen}>
      {showPagination && (
        <Pagination>
          {isDetailView || isFullscreen ? (
            <>
              <Button
                onClick={onPageDown}
                icon="chevron-small-down"
                isDisabled={page.to >= totalItems}
                variant="tertiary"
                size="s"
              />
              <Button
                onClick={onPageUp}
                icon="chevron-small-up"
                isDisabled={page.from === 1}
                variant="tertiary"
                size="s"
              />
              <Counter isDetailView>
                {page.from} - {page.to}
              </Counter>
            </>
          ) : (
            <>
              <Button
                onClick={onPageUp}
                icon="chevron-small-left"
                isDisabled={page.from === 1}
                variant="tertiary"
                size="xs"
              />
              <Counter>
                {tr(locale, "INSIGHT_PAGES::PAGINATION", {
                  from: page.from.toString(),
                  to: page.to.toString(),
                  length: totalItems.toString(),
                })}
              </Counter>
              <Button
                onClick={onPageDown}
                icon="chevron-small-right"
                isDisabled={page.to >= totalItems}
                variant="tertiary"
                size="xs"
              />
            </>
          )}
        </Pagination>
      )}
      {!showPagination && <div style={{ width: 10 }} />}
      {(isFullscreen || isDetailView) && !!onClick && (
        <Button
          onClick={onClick}
          text={tr(locale, "POST::RELATED")}
          variant="tertiary"
          size="xs"
          isDisabled={!!!onClick}
        />
      )}
    </Footer>
  );
};

export default RadarlyWidgetImageClusteringFooter;
